import React from 'react';
import { AuthProvider } from '@/contexts/AuthContext';
import { PaymentModeProvider } from '@/contexts/PaymentModeContext';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from '@/pages/Home';
import Login from '@/pages/Login';
import Account from '@/pages/Account';
import MovieDetail from '@/pages/MovieDetail';
import WatchMovie from '@/pages/WatchMovie';
import SearchResults from '@/pages/SearchResults';
import Favorites from '@/pages/Favorites';
import AdminPanel from '@/pages/AdminPanel';

function App() {
  return (
    <PaymentModeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/search" element={<SearchResults />} />
            <Route path="/favoris" element={<Favorites />} />
            <Route path="/login" element={<Login />} />
            <Route path="/compte" element={<Account />} />
            <Route path="/film/:movieId" element={<MovieDetail />} />
            <Route path="/regarder/:movieId" element={<WatchMovie />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
    </PaymentModeProvider>
  );
}

export default App;
